import { Connection } from '../../administration/clientAdministrationPage/types';
import Config from '../../config';
import { QueryKeys, useCustomQuery } from './index';

type UseAdminConnectionsParams = { periodName: string };
export const useAdminConnections = ({ periodName }: UseAdminConnectionsParams) => useCustomQuery<Connection[]>(
  [QueryKeys.clientAdministration.ConnectionsList, { periodName }],
  {
    url: Config.endpoints.FETCH_ADMIN_CONNECTIONS
      .replace(/:periodName/, periodName),
    errorMessage: 'Fetching connections failed',
    defaultData: [],
    enabled: true,
  }
);

export const useConnectionTypeValues = () => useCustomQuery<{ value: string; name: string }[]>(
  [QueryKeys.clientAdministration.ConnectionTypeValues],
  {
    url: Config.endpoints.FETCH_CONNECTION_TYPE,
    errorMessage: 'Fetching connection type values failed',
    defaultData: [],
    enabled: true,
  }
);

export const useInboundFormatValues = () => useCustomQuery<{ value: string; name: string }[]>(
  [QueryKeys.clientAdministration.InboundFormatValues],
  {
    url: Config.endpoints.FETCH_INBOUND_FORMAT,
    errorMessage: 'Fetching inbound format values failed',
    defaultData: [],
    enabled: true,
  }
);

export const useOutboundFormatValues = () => useCustomQuery<{ value: string; name: string }[]>(
  [QueryKeys.clientAdministration.OutboundFormatValues],
  {
    url: Config.endpoints.FETCH_OUTBOUND_FORMAT,
    errorMessage: 'Fetching outbound format values failed',
    defaultData: [],
    enabled: true,
  }
);

export const useYesNoFlagValues = () => useCustomQuery<{ value: string }[]>(
  [QueryKeys.clientAdministration.YesNoFlagValues],
  {
    url: Config.endpoints.FETCH_YES_NO_FLAG,
    errorMessage: 'Fetching yes no flag values failed',
    defaultData: [],
    enabled: true,
  }
);

const convertToOptions = (entities: { value: string; name: string }[]) =>
  entities.map(({ name, value }) => ({ label: name, value }));


export const useLookUpDataForAddEditConnectionModal = () => {
  const { data: connectionTypeValues, isFetching: isFetchingConnectionTypeValues } = useConnectionTypeValues();
  const { data: inboundFormatValues, isFetching: isFetchingInboundFormatValues } = useInboundFormatValues();
  const { data: outboundFormatValues, isFetching: isFetchingOutboundFormatValues } = useOutboundFormatValues();
  const { data: yesNoFlagData, isFetching: isFetchingYesNoFlagValues } = useYesNoFlagValues();

  const yesNoFlagValues = yesNoFlagData.map(({ value }) => ({ value, label: value }));

  return {
    data: {
      connectionTypeOptions: convertToOptions(connectionTypeValues),
      inboundFormatOptions: convertToOptions(inboundFormatValues),
      outboundFormatOptions: convertToOptions(outboundFormatValues),
      enabledFlagOptions: yesNoFlagValues,
      esFlagOptions: yesNoFlagValues,
      generateJeFlagOptions: yesNoFlagValues,
      bsmJeFlagOptions: yesNoFlagValues,
      deleteRawTbDataOptions: yesNoFlagValues,
      inlineReportGenerationOptions: yesNoFlagValues,
    },
    isFetching: isFetchingConnectionTypeValues
      || isFetchingInboundFormatValues
      || isFetchingOutboundFormatValues
      || isFetchingYesNoFlagValues,
  };
};
